// import { SimpleList } from 'components-modules/simple-list';
// export default SimpleList;
export default {};
